export function buildHierarchy(data, parentId = null) {
  const children = data.filter(item => item.parent_id === parentId);

  if (children.length === 0) {
    return [];
  }

  const result = children
    .sort((a, b) => (a.priority || 100) - (b.priority || 100))
    .map(child => {
      let childernData = buildHierarchy(data, child.id);
      const childNode = {
        ...child,
        isExpand: true,
        checked: true,
        label: child.name,
        value: child.id,
        // Sorting Metrics with priority order
        children: childernData.sort((a, b) => (a?.priority || 100) - (b?.priority || 100)),
      };
      return childNode;
    });

  return result;
}
